export default "__VITE_ASSET__2chB1e7I__"